<mat-card>{{'notifications' | translate}}</mat-card>

<mat-grid-list cols="5" rowHeight="70px">
  <mat-grid-tile colspan="1"></mat-grid-tile>
  <mat-grid-tile colspan="2">
    <mat-form-field appearance="standard">
      <mat-label>{{'userCatg' | translate}}</mat-label>

      <mat-select [disabled]="selectAllType" [(ngModel)]="selectedUserType" (selectionChange)="userTypeChange()">
        <!-- <app-select-check-all [model]="$any(form).controls['customer']" [values]="customers">
			</app-select-check-all> -->
        <mat-option *ngFor="let item of usersType" [value]="item.id">
          {{item.name | translate}}
        </mat-option>
      </mat-select>

    </mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile colspan="1">
    <mat-checkbox class="example-margin" [(ngModel)]="selectAllType">{{'all' | translate}}</mat-checkbox>
  </mat-grid-tile>
</mat-grid-list>

<mat-grid-list cols="5" rowHeight="70px" *ngIf="selectedUserType == 1">
  <mat-grid-tile colspan="1"></mat-grid-tile>
  <mat-grid-tile colspan="2">
    <mat-form-field appearance="standard">
      <mat-label>{{'users' | translate}}</mat-label>

      <mat-select multiple [disabled]="selectAll || selectAllType " [(ngModel)]="selectedCustomers">
        <!-- <app-select-check-all [model]="$any(form).controls['customer']" [values]="customers">
			</app-select-check-all> -->
        <mat-option *ngFor="let customer of customers" [value]="customer.id">
          {{customer.fullName}}
        </mat-option>
      </mat-select>

    </mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile colspan="1">
    <mat-checkbox class="example-margin" [(ngModel)]="selectAll">{{'all' | translate}}</mat-checkbox>
  </mat-grid-tile>
</mat-grid-list>

<mat-grid-list cols="5" rowHeight="70px" *ngIf="selectedUserType == 2">
  <mat-grid-tile colspan="1"></mat-grid-tile>
  <mat-grid-tile colspan="2">
    <mat-form-field appearance="standard">
      <mat-label>{{'MandoobsMenu' | translate}}</mat-label>

      <mat-select multiple [disabled]="selectAll" [(ngModel)]="selectedMandoobs">

        <mat-option *ngFor="let item of mandoobs" [value]="item.id">
          {{item.fullName}}
        </mat-option>
      </mat-select>

    </mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile colspan="1">
    <mat-checkbox class="example-margin" [(ngModel)]="selectAll">{{'all' | translate}}</mat-checkbox>
  </mat-grid-tile>
</mat-grid-list>

<mat-grid-list cols="5" rowHeight="70px">
  <mat-grid-tile colspan="1"></mat-grid-tile>
  <mat-grid-tile colspan="2">
    <mat-form-field appearance="standard">
      <mat-label>{{'title' | translate}}</mat-label>
      <input matInput required [(ngModel)]="title">
      <!-- <mat-error *ngIf="title1.invalid">{{'requiredField' | translate}}</mat-error> -->
    </mat-form-field>
  </mat-grid-tile>
</mat-grid-list>

<mat-grid-list cols="5" rowHeight="70px">
  <mat-grid-tile colspan="1"></mat-grid-tile>
  <mat-grid-tile colspan="2">
    <mat-form-field appearance="standard">
      <mat-label>{{'body' | translate}}</mat-label>
      <textarea matInput [(ngModel)]="body"></textarea>
      <!-- <mat-error *ngIf="body1.invalid">{{'requiredField' | translate}}</mat-error> -->
    </mat-form-field>
  </mat-grid-tile>
</mat-grid-list>


<mat-grid-list cols="4" rowHeight="100px">
  <mat-grid-tile></mat-grid-tile>
  <mat-grid-tile>

    <!-- [disabled]="title1.invalid || body1.invalid" -->
    <button mat-raised-button color="primary" (click)="submit()" [disabled]="
      ((!selectAllType && !selectAll) &&
      (selectedCustomers.length == 0 && selectedMandoobs.length == 0)) ||
       (title == '' ||  body == '' || title == null || body == null)">
      <mat-icon>done</mat-icon>
      {{'send' | translate}}</button>
  </mat-grid-tile>
</mat-grid-list>

<hr />

<div class="container" style="padding: 25px;">
  <mat-grid-list cols="4" rowHeight="50px">
    <mat-grid-tile cols="2">
      <mat-form-field appearance="standard">
        <mat-label>{{'filter' | translate}}</mat-label>
        <input matInput (keyup)="applyFilter($event)" #input>
      </mat-form-field>
    </mat-grid-tile>
  </mat-grid-list>

  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="createDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'dateTime' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.createDate | date: 'dd/MM/yyyy hh:mm a'}} </td>
      </ng-container>

      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'title' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.title}} </td>
      </ng-container>

      <ng-container matColumnDef="message">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'body' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.message}} </td>
      </ng-container>

      <ng-container matColumnDef="delete">
        <th mat-header-cell *matHeaderCellDef> {{'delete' | translate}} </th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button (click)="onDelete(row.id)">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">{{'noDataMatchingTheFilter' | translate}}</td>
      </tr>
    </table>

    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
  </div>
</div>

<ng-template #ModalConfirmDelete>
  <h1 mat-dialog-title>{{'confirm' | translate}}</h1>
  <div mat-dialog-content>
    <p>{{'areYouSureToDelete' | translate}}</p>
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
    <button mat-button cdkFocusInitial (click)="confirmDelete()">{{'yes' | translate}}</button>
  </div>
</ng-template>

<app-matspinner [overlay]="spinnerOverlay"></app-matspinner>